import { useEffect, useState } from "react";
import { MailCheck } from "lucide-react";
import { API } from "@/lib/api";

const SubscribersList = () => {
  const [subs, setSubs] = useState(null);

  useEffect(() => {
    API.get("/admin/subscribers").then(({ data }) => setSubs(data)).catch(() => setSubs([]));
  }, []);

  if (subs === null)
    return <div className="mt-8 h-32 animate-pulse rounded-2xl border border-edge bg-ink2" />;

  return (
    <div className="mt-8" data-testid="subscribers-list">
      <p className="mb-4 font-mono-score text-xs uppercase tracking-widest text-slate-400">
        {subs.length} seguidor(es) suscritos
      </p>
      {subs.length === 0 ? (
        <div className="py-16 text-center text-slate-500">
          <MailCheck className="mx-auto mb-3 h-8 w-8 text-slate-600" />
          Aún no hay suscriptores. Comparte la web y la lista crecerá.
        </div>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {subs.map((s) => (
            <div key={s.id} className="rounded-2xl border border-edge bg-ink2 p-4" data-testid={`subscriber-${s.id}`}>
              <p className="truncate font-mono-score text-sm text-white">{s.email}</p>
              <p className="mt-1 font-mono-score text-[10px] uppercase tracking-widest text-slate-500">
                {s.created_at?.slice(0, 10)}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SubscribersList;
